<template>
  <div class="contact-information-index flex-start">
    <el-select
      class="code"
      v-model="currentCode"
      placeholder="Area Code"
      popper-class="AreaCodePopper"
      @change="changeCode"
    >
      <el-option v-for="item in list" :key="item.label_en" :value="item.value">
        <div class="flex-between">
          <span>{{ language == "zh" ? item.label : item.label_en }}</span>
          <span>{{ item.value }}</span>
        </div>
      </el-option>
    </el-select>
    <el-input
      class="phone"
      v-model="currentPhone"
      placeholder="Your Contact Information"
      @input="handlePhone"
    ></el-input>
  </div>
</template>

<script>
import CountryCodes from "@/utils/country_codes.js"; // 国家及行政区的区号列表（可能不全）
export default {
  name: "ContactInfo",
  props: {
    areacode: {
      type: String,
      default: "", // 区号
    },
    phone: {
      type: String,
      default: "", // 手机号
    },
    language: {
      type: String,
      default: "zh", // zh, en
    },
    defaultCode: {
      type: String,
      default: "+65", // 默认区号 新加坡：+65
    },
  },
  data() {
    return {
      currentCode: this.areacode,
      currentPhone: this.phone,
      list: [],
    };
  },
  watch: {
    phone: function (val) {
      this.currentPhone = val;
    },
  },
  created() {},
  mounted() {
    this.list = CountryCodes;
  },
  methods: {
    changeCode() {
      this.$emit("update:areacode", this.currentCode);
    },
    handlePhone() {
      this.$emit("update:phone", this.currentPhone);
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-information-index {
  .code {
    width: 32%;
  }
  .phone {
    width: 68%;
  }

  .flex-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
.AreaCodePopper {
  .popper__arrow {
    display: none;
  }
  .el-scrollbar__view {
    padding: 0;
  }
  .el-select-dropdown__item {
    height: 48px;
    line-height: 48px;
    font-weight: 400;
    font-size: 16px;
    color: #1d1d1f;
    text-align: justify;
    font-style: normal;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item.selected,
  .el-select-dropdown__item:hover {
    background-color: #f5f7fa;
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
